// import { Modal as AntModal } from "antd";
// import { Box, Typography, Button } from "@mui/material";
// import WarningAmberIcon from "@mui/icons-material/WarningAmber";

// export default function BranchInactiveAndCreditLimit({ visible, onClose }) {
//   return (
//     <AntModal
//       open={visible}
//       onCancel={onClose}
//       footer={null}
//       centered
//       closable={true}
//       maskClosable={false}
//       keyboard={false}
//       bodyStyle={{
//         padding: "24px",
//         fontFamily: "Inter, sans-serif",
//       }}
//     >
//       {/* First Card */}
//       <Box
//         sx={{
//           border: "1px solid #e0e0e0",
//           borderRadius: "8px",
//           p: 2,
//           backgroundColor: "#fff",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
//           <WarningAmberIcon sx={{ color: "#FF9800", mt: 0.3 }} />
//           <Box>
//             <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
//               Job Posting Disabled
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ color: "#555", mb: 1.5, lineHeight: 1.5 }}
//             >
//               Your branch has reached its credit limit.
//             </Typography>
//             <Typography variant="body2" sx={{ color: "#777", lineHeight: 1.5 }}>
//               Please contact our finance team at{" "}
//               <a
//                 href="mailto:finance@jobizo.com"
//                 style={{ color: "#007bff", textDecoration: "none" }}
//               >
//                 finance@jobizo.com
//               </a>{" "}
//               to clear outstanding dues.
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* Second Card */}
//       <Box
//         sx={{
//           border: "1px solid #e0e0e0",
//           borderRadius: "8px",
//           p: 2,
//           backgroundColor: "#fff",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
//           <WarningAmberIcon sx={{ color: "#FF9800", mt: 0.3 }} />
//           <Box>
//             <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
//               Job Posting Disabled
//             </Typography>
//             <Typography variant="body2" sx={{ color: "#777", lineHeight: 1.5 }}>
//               Your branch is inactive. Contact our support team at{" "}
//               <a
//                 href="mailto:support@jobizo.com"
//                 style={{ color: "#007bff", textDecoration: "none" }}
//               >
//                 support@jobizo.com
//               </a>
//             </Typography>
//           </Box>
//         </Box>
//       </Box>
//     </AntModal>
//   );
// }

import { Modal as AntModal } from "antd";
import { Box, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function BranchInactiveAndCreditLimit({ visible, onClose }) {
  const cards = [
    {
      title: "Job Posting Disabled",
      desc1: "Your branch has reached its credit limit.",
      desc2: (
        <>
          Please contact our finance team at{" "}
          <a
            href="mailto:finance@jobizo.com"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            finance@jobizo.com
          </a>{" "}
          to clear outstanding dues.
        </>
      ),
    },
    {
      title: "Job Posting Disabled",
      desc1: (
        <>
          Your branch is inactive. Contact our support team at{" "}
          <a
            href="mailto:support@jobizo.com"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            support@jobizo.com
          </a>
          .
        </>
      ),
    },
  ];

  return (
    <AntModal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable
      maskClosable={false}
      keyboard={false}
      bodyStyle={{
        padding: "24px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {cards.map((card, index) => (
        <Box
          key={index}
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            p: 2,
            backgroundColor: "#fff",
            mb: index === cards.length - 1 ? 0 : 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <WarningAmberIcon sx={{ color: "#FF9800", mt: 0.4 }} />
            <Box>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                {card.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#555", mb: card.desc2 ? 1.5 : 0, lineHeight: 1.5 }}
              >
                {card.desc1}
              </Typography>
              {card.desc2 && (
                <Typography
                  variant="body2"
                  sx={{ color: "#777", lineHeight: 1.5 }}
                >
                  {card.desc2}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      ))}
    </AntModal>
  );
}

